module.exports = __webpack_public_path__ + "static/media/admin_canvas_back_icon.9a42961e.svg";